import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { StorageService } from 'src/app/tools/storage.service';
import { IxellAPIService, IProductV1, ProductType, ScaleSelect, Roles, ActivationLicenceInfo } from 'src/app/tools/api.service';
import { UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderService } from 'src/app/tools/header.service';
import { ErrorService } from 'src/app/tools/error.service';
import { Language } from 'src/app/entities/Language';
import { MatRadioChange } from '@angular/material/radio';
import { Utils } from 'src/app/tools/utils';

@Component({
    selector: 'laca_catalogue',
    templateUrl: './catalogue.component.html',
    styleUrls: ['./catalogue.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CatalogueComponent implements OnInit, OnDestroy {

    constructor(private storage: StorageService, private apiService: IxellAPIService, private router: Router, private headerService: HeaderService, private route: ActivatedRoute, private errorService: ErrorService) { }

    products: IProductV1[] = [];
    productsAvailable: IProductV1[] = [];
    productsFiltered: IProductV1[] = [];
    ProductType: ProductType;
    cart: any[] = [];
    scales: ActivationLicenceInfo[] = [];
    scalesBackupAndStats: ActivationLicenceInfo[] = [];
    actualScale: ActivationLicenceInfo = new ActivationLicenceInfo();
    actualScaleBackupAndStats: ActivationLicenceInfo = new ActivationLicenceInfo();

    scaleDetail: ActivationLicenceInfo = new ActivationLicenceInfo();
    scaleDetailBackupAndStats: ActivationLicenceInfo = new ActivationLicenceInfo();

    private langue: Language;
    private langueSub: any;

    selectedFilter: number = 1;
    selectScale = new UntypedFormControl('');
    selectScaleBackupAndStats = new UntypedFormControl('');
    scaleSelected: number = 0;

    role: Roles = Roles.Unknown;
    scaleSelect = false;
    scaleSelectBackupAndStats = false;

    canAddToCart: boolean;
    canDecreaseQty: boolean;

    licenceDuration: any;
    licenceDurationSub: any;
    private roleSub: any;
    productSub: any;
    licenceSub: any;
    scale: any;
    currentProduct: IProductV1;
    showModal: boolean = false;
    showModalNoRenew: boolean = false;
    showZoom: boolean = false;

    isLicenceProduct: boolean = false;

    ngOnInit() {

        //this.apiService.confirmPaymentPayzen().subscribe(data => { });

        this.headerService.changeTitle("support.supportAssistance");
        this.scale = this.storage.get("scale");
        if (this.scale == null)
            this.scale = "4";
        this.roleSub = this.headerService.currentRole.subscribe(role => {
            this.role = role
        }, error => {
            console.log(error);
            if (this.roleSub != null) this.roleSub.unsubscribe();
        });

        let code = this.route.snapshot.paramMap.get('code');
        if (code) {
            sessionStorage.setItem("catalogueCode", code);
            this.router.navigate(["login"]);
        } else {
            let catalogueCode: string = sessionStorage.getItem("catalogueCode");
            if (catalogueCode) {
                sessionStorage.removeItem("catalogueCode");
                this.headerService.verifyRole();
            }
        }

        this.langueSub = this.headerService.currentLangue.subscribe(langue => {
            this.langue = langue;
        }, error => {
            console.log(error);
            if (this.langueSub != null) this.langueSub.unsubscribe();
        });
        this.selectedFilter = 1;

        // Met les balances dans le select
        this.licenceSub = this.apiService.activationsLicence().subscribe(data => {
            if (data.length > 0) {
                this.scales = data;
                if (data.length == 1) {
                    const daysDiff = Math.trunc((data[0].licenceEnd.getTime() - (new Date()).getTime()) / (1000 * 60 * 60 * 24));
                    if (daysDiff <= 45) {
                        this.selectScale.setValue(data[0].activationID);
                        this.scaleSelected = data[0].activationID;
                        this.scaleSelect = true;
                        //this.licenceScale(data[0]);
                        this.actualScale = data[0];
                        this.getLicenceDuration();
                        this.scaleDetail = data[0];
                    }
                }

                this.scalesBackupAndStats = data.filter((s) => s.licenceStart.toISOString().split('T')[0] < "2024-07-01" && s.dateActivationLicence.toISOString().split('T')[0] < "2024-07-01" && s.licenceEnd.toISOString().split('T')[0] > "2024-07-01");
                if (this.scalesBackupAndStats.length == 0) {
                    let index = this.productsFiltered.findIndex(x => x.labelP == "Abonnement Backup & Statistiques");
                    this.productsFiltered.splice(index, 1);
                    index = this.productsAvailable.findIndex(x => x.labelP == "Abonnement Backup & Statistiques");
                    this.productsAvailable.splice(index, 1);
                }
            } else {
                //let indexP = this.products.findIndex(el => el.typeP == ProductType.Licence);
                //this.productsAvailable.splice(indexP, 1);
            }

            this.productSub = this.apiService.selectProducts().subscribe(prods => {
                // Met en place les produits
                this.products = prods;
                this.products.forEach(
                    element => {
                        if (this.scale == (this.scale & element.associatedScale)) {
                            if (element.available) {
                                if (element.typeP == ProductType.Licence && Utils.isCTC(this.role)) {
                                }
                                else {
                                    this.productsAvailable.push(element);
                                    this.productsFiltered.push(element);
                                }
                            }
                            element.typeName = ProductType[element.typeP]
                        }
                    });
                // Récupère le panier en localStorage
                let storedCart = JSON.parse(localStorage.getItem("cart"));
                if (storedCart) {
                    // Si le panier , met la quantité à jour 
                    this.cart = storedCart;
                    this.cart.forEach(el => {
                        this.canAddToCart = true;
                        let index = this.products.findIndex(i => i.labelP == el.product);
                        this.products[index].qte = el.qty;
                        if (this.products[index].qte === 0) {
                            let indexC = this.cart.findIndex(i => i.product == name);
                            this.cart.splice(indexC, 1);
                            this.headerService.changeNbProduct(this.cart.length);
                            this.headerService.changeProducts(JSON.stringify(this.cart));
                            localStorage.setItem("cart", JSON.stringify(this.cart));
                        }

                        if (el.scale && this.products[index].qte != 0) {
                            this.canAddToCart = true;
                            this.canDecreaseQty = true;
                            if (this.products[index].labelP == "Licence IxellColor Connect") {
                                this.actualScale = new ActivationLicenceInfo();
                                let scaleI = this.scales.findIndex(i => i.activationID == el.activation);
                                if (scaleI >= 0) {
                                    const daysDiff = Math.trunc((this.scales[scaleI].licenceEnd.getTime() - (new Date()).getTime()) / (1000 * 60 * 60 * 24));
                                    if (daysDiff <= 45) {
                                        this.selectScale.setValue(el.activation);
                                        this.actualScale = this.scales[scaleI];
                                        if (this.actualScale) {
                                            this.scaleDetail = this.actualScale;
                                            this.scaleSelect = true;
                                            this.getLicenceDuration();
                                        }
                                    }
                                }
                            }
                            else if (this.products[index].labelP == "Abonnement Backup & Statistiques") {
                                this.actualScaleBackupAndStats = new ActivationLicenceInfo();
                                this.selectScaleBackupAndStats.setValue(el.activation);
                                let scaleI = this.scalesBackupAndStats.findIndex(i => i.activationID == el.activation);
                                if (scaleI >= 0) {
                                    this.actualScaleBackupAndStats = this.scalesBackupAndStats[scaleI];
                                    if (this.actualScaleBackupAndStats) {
                                        this.scaleDetailBackupAndStats = this.actualScaleBackupAndStats;
                                        this.scaleSelectBackupAndStats = true;
                                    }
                                }
                            }
                        } else {
                            this.actualScale = new ActivationLicenceInfo();
                        }
                    })
                }
            }, error => {
                this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "selectProducts", new Date().toString());
                if (this.productSub != null) this.productSub.unsubscribe();
                console.log(error);
            });
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "activationsLicence", new Date().toString());
            if (this.licenceSub != null) this.licenceSub.unsubscribe();
            console.log(error);
        })
    }

    ngOnDestroy() {
        if (this.productSub != null) this.productSub.unsubscribe();
        if (this.licenceSub != null) this.licenceSub.unsubscribe();
        if (this.licenceDurationSub != null) this.licenceDurationSub.unsubscribe();
        if (this.langueSub != null) this.langueSub.unsubscribe();
        if (this.roleSub != null) this.roleSub.unsubscribe();
    }

    radioChange(name: string) {
        this.productsFiltered = [];
        switch (name) {
            case "All":
                this.productsFiltered = this.productsAvailable;
                break;
            case (ProductType[ProductType.Licence]):
                this.productsAvailable.forEach(element => {
                    if (ProductType[element.typeP] == ProductType[ProductType.Licence])
                        this.productsFiltered.push(element);
                });
                break;
            case (ProductType[ProductType.Support]):
                this.productsAvailable.forEach(element => {
                    if (ProductType[element.typeP] == ProductType[ProductType.Support])
                        this.productsFiltered.push(element);
                });
                break;
            case (ProductType[ProductType.Cables]):
                this.productsAvailable.forEach(element => {
                    if (ProductType[element.typeP] == ProductType[ProductType.Cables])
                        this.productsFiltered.push(element);
                });
                break;
            case (ProductType[ProductType.Reseau]):
                this.productsAvailable.forEach(element => {
                    if (ProductType[element.typeP] == ProductType[ProductType.Reseau])
                        this.productsFiltered.push(element);
                });
                break;
            case (ProductType[ProductType.Divers]):
                this.productsAvailable.forEach(element => {
                    if (ProductType[element.typeP] == ProductType[ProductType.Divers])
                        this.productsFiltered.push(element);
                });
                break;
        }
    }

    licenceScaleBackupAndStats(scale: ActivationLicenceInfo) {
        let index = this.products.findIndex(i => i.labelP == "Abonnement Backup & Statistiques");

        // on supprime systématiquement l'existant en cas de selection avant ajout
        this.products[index].qte = 0;
        this.products[index].qteStock = 0;
        let indexC = this.cart.findIndex(i => i.product == name);
        this.cart.splice(indexC, 1);
        this.headerService.changeNbProduct(this.cart.length);
        this.headerService.changeProducts(JSON.stringify(this.cart));
        localStorage.setItem("cart", JSON.stringify(this.cart));

        //ajout
        let scaleI = this.scalesBackupAndStats.findIndex(i => i.activationID == this.selectScaleBackupAndStats.value);
        this.actualScaleBackupAndStats = this.scalesBackupAndStats[scaleI];
        if (this.products[index].qte == 0)
            this.addProduct("Abonnement Backup & Statistiques", scale);
        this.products[index].qte = this.products[index].qte == 0 ? 1 : this.products[index].qte;
        this.scaleSelectBackupAndStats = true;

        this.scaleDetailBackupAndStats = this.scalesBackupAndStats[scaleI];
    }

    licenceScale(scale: ActivationLicenceInfo) {
        // Au changement de la balance dans le select
        let scaleI = this.scales.findIndex(i => i.activationID == this.selectScale.value);
        const daysDiff = Math.trunc((this.scales[scaleI].licenceEnd.getTime() - (new Date()).getTime()) / (1000 * 60 * 60 * 24));
        if (daysDiff > 45) {
            this.actualScale = new ActivationLicenceInfo();
            this.selectScale.setValue(null);
            this.scaleSelect = false;
            this.scaleDetail = null;
            this.licenceDuration = '';
            this.removeProduct("Licence IxellColor Connect");
            this.openNoRenewModal();
            return;
        }

        this.actualScale = this.scales[scaleI];
        this.getLicenceDuration();
        // this.addProduct("Licence IxellColor Connect");
        let index = this.products.findIndex(i => i.labelP == "Licence IxellColor Connect");
        if (this.products[index].qte == 0)
            this.addProduct("Licence IxellColor Connect", scale);
        this.products[index].qte = this.products[index].qte == 0 ? 1 : this.products[index].qte;
        this.scaleSelect = true;

        this.scaleDetail = this.scales[scaleI];

        if (this.scaleSelectBackupAndStats) {
            if (this.actualScaleBackupAndStats.activationID == this.actualScale.activationID) {
                this.removeProduct("Abonnement Backup & Statistiques");
            }
        }
    }

    getLicenceDuration() {
        if (this.actualScale && this.actualScale.activationID) {
            this.licenceDurationSub = this.apiService.getLicenceDuration(this.actualScale.activationID).subscribe(data => {
                if (data) {
                    let res = data.toISOString().slice(0, 10);
                    this.licenceDuration = res;
                } else {
                    this.licenceDuration = '';
                }
            }, error => {
                if (this.licenceDurationSub != null) this.licenceDurationSub.unsubscribe();
                console.log(error);
            })
        }
    }

    addProduct(name: string, scale: ActivationLicenceInfo) {
        // Attention, scale est != null uniquement pour le cas "Abonnement Backup & Statistiques"

        sessionStorage.removeItem("cartCode");
        let index = this.products.findIndex(i => i.labelP == name);
        if (this.products[index].qteStock == 0 || this.products[index].qte < this.products[index].qteStock) {
            this.products[index].qte++;
            //let price = this.products[index].amountP * this.products[index].qte;
            //this.products[index].amountP = price;
            if (this.selectScale.value && name == "Licence IxellColor Connect") {
                let index = this.products.findIndex(i => i.labelP == name);
                let qteStr = this.products[index].qte.toString();
                let price = this.products[index].amountP;
                let totalPrice = price * this.products[index].qte;

                let item = {
                    designation: {
                        'fr': this.products[index].labelP,
                        'en': this.products[index].labelENP,
                        'de': this.products[index].labelDEP,
                        'es': this.products[index].labelESP,
                        'it': this.products[index].labelITP,
                        'nl': this.products[index].labelNLP,
                        'ro': this.products[index].labelROP,
                        'pt': this.products[index].labelPTP,
                        'pl': this.products[index].labelPLP,
                        'tr': this.products[index].labelTRP
                    },
                    fraisLiv: {
                        'fr': this.products[index].fraisLivP,
                        'be': this.products[index].fraisLivBEP,
                        'de': this.products[index].fraisLivDEP,
                        'es': this.products[index].fraisLivESP,
                        'it': this.products[index].fraisLivITP,
                        'nl': this.products[index].fraisLivNLP,
                        'ro': this.products[index].fraisLivROP,
                        'pt': this.products[index].fraisLivPTP,
                        'pl': this.products[index].fraisLivPLP,
                        'tr': this.products[index].fraisLivTRP
                    },
                    fraisLivManuel: this.products[index].fraisLivManuel,
                    product: this.products[index].labelP,
                    scale: this.actualScale.code,
                    qty: qteStr,
                    type: this.products[index].typeP,
                    qtyMax: this.products[index].qteStock,
                    amount: price,
                    tPrice: totalPrice,
                    activation: this.actualScale.activationID,
                    pId: this.products[index].productID,
                    cu: this.actualScale.unisiteCode
                };

                let cartLicence = this.cart.findIndex(el => el.product == "Licence IxellColor Connect");
                if (cartLicence > -1) {
                    let licenceI = this.cart.findIndex(i => i.product == name);
                    this.cart[licenceI] = item;
                    localStorage.setItem("cart", JSON.stringify(this.cart));
                } else {
                    this.cart.push(item);
                    localStorage.setItem("cart", JSON.stringify(this.cart));
                }
                this.canAddToCart = true;
                this.canDecreaseQty = true;
                this.headerService.changeNbProduct(this.cart.length);
                this.headerService.changeProducts(JSON.stringify(this.cart));
            }
            else if (this.selectScaleBackupAndStats.value && name == "Abonnement Backup & Statistiques") {
                let dateNow = Date.now();
                let diffDate = scale.licenceEnd.getTime() - dateNow;
                let month = Math.round(((((diffDate / 1000) / 60) / 60) / 24) / 30);
                // si on est dans le mois de fin de licence => month == 0 donc passer month à 1 pour avoir un prix != 0
                if (month == 0) month++;

                let index = this.products.findIndex(i => i.labelP == name);
                this.products[index].qte = month;
                this.products[index].qteStock = month;
                let qteStr = this.products[index].qte.toString();
                let price = this.products[index].amountP;
                let totalPrice = price * this.products[index].qte;

                let item = {
                    designation: {
                        'fr': this.products[index].labelP,
                        'en': this.products[index].labelENP,
                        'de': this.products[index].labelDEP,
                        'es': this.products[index].labelESP,
                        'it': this.products[index].labelITP,
                        'nl': this.products[index].labelNLP,
                        'ro': this.products[index].labelROP,
                        'pt': this.products[index].labelPTP,
                        'pl': this.products[index].labelPLP,
                        'tr': this.products[index].labelTRP
                    },
                    fraisLiv: {
                        'fr': this.products[index].fraisLivP,
                        'be': this.products[index].fraisLivBEP,
                        'de': this.products[index].fraisLivDEP,
                        'es': this.products[index].fraisLivESP,
                        'it': this.products[index].fraisLivITP,
                        'nl': this.products[index].fraisLivNLP,
                        'ro': this.products[index].fraisLivROP,
                        'pt': this.products[index].fraisLivPTP,
                        'pl': this.products[index].fraisLivPLP,
                        'tr': this.products[index].fraisLivTRP
                    },
                    fraisLivManuel: this.products[index].fraisLivManuel,
                    product: this.products[index].labelP,
                    scale: this.actualScaleBackupAndStats.code,
                    qty: qteStr,
                    type: this.products[index].typeP,
                    qtyMax: this.products[index].qteStock,
                    amount: price,
                    tPrice: totalPrice,
                    activation: this.actualScaleBackupAndStats.activationID,
                    pId: this.products[index].productID,
                    cu: this.actualScaleBackupAndStats.unisiteCode
                };

                let cartBackupAndStats = this.cart.findIndex(el => el.product == "Abonnement Backup & Statistiques");
                if (cartBackupAndStats > -1) {
                    let index = this.cart.findIndex(i => i.product == name);
                    this.cart[index] = item;
                    localStorage.setItem("cart", JSON.stringify(this.cart));
                } else {
                    this.cart.push(item);
                    localStorage.setItem("cart", JSON.stringify(this.cart));
                }

                this.canAddToCart = true;
                this.canDecreaseQty = true;
                this.headerService.changeNbProduct(this.cart.length);
                this.headerService.changeProducts(JSON.stringify(this.cart));
            }
            else {
                let index = this.products.findIndex(i => i.labelP == name);
                let qteStr = this.products[index].qte.toString();
                let price = this.products[index].amountP;
                let totalPrice = price * this.products[index].qte;

                let item = {
                    designation: {
                        'fr': this.products[index].labelP,
                        'en': this.products[index].labelENP,
                        'de': this.products[index].labelDEP,
                        'es': this.products[index].labelESP,
                        'it': this.products[index].labelITP,
                        'nl': this.products[index].labelNLP,
                        'ro': this.products[index].labelROP,
                        'pt': this.products[index].labelPTP,
                        'pl': this.products[index].labelPLP,
                        'tr': this.products[index].labelTRP
                    },
                    fraisLiv: {
                        'fr': this.products[index].fraisLivP,
                        'be': this.products[index].fraisLivBEP,
                        'de': this.products[index].fraisLivDEP,
                        'es': this.products[index].fraisLivESP,
                        'it': this.products[index].fraisLivITP,
                        'nl': this.products[index].fraisLivNLP,
                        'ro': this.products[index].fraisLivROP,
                        'pt': this.products[index].fraisLivPTP,
                        'pl': this.products[index].fraisLivPLP,
                        'tr': this.products[index].fraisLivTRP
                    },
                    fraisLivManuel: this.products[index].fraisLivManuel,
                    product: this.products[index].labelP,
                    qty: qteStr,
                    type: this.products[index].typeP,
                    qtyMax: this.products[index].qteStock,
                    amount: price,
                    tPrice: totalPrice,
                    pId: this.products[index].productID
                };

                if (this.cart.length > 0) {
                    let productI = this.cart.findIndex(i => i.product == name);
                    if (productI > -1) {
                        this.cart[productI] = item;
                    } else {
                        this.cart.push(item);
                    }
                    localStorage.setItem("cart", JSON.stringify(this.cart));
                } else {
                    this.cart.push(item);
                    localStorage.setItem("cart", JSON.stringify(this.cart));
                }
                this.canAddToCart = true;
                this.canDecreaseQty = true;
                this.headerService.changeNbProduct(this.cart.length);
                this.headerService.changeProducts(JSON.stringify(this.cart));
            }

        }
    }

    removeProduct(name: string) {
        let index = this.products.findIndex(i => i.labelP == name);

        if (this.products[index].typeP == ProductType.Licence && this.products[index].labelP == "Abonnement Backup & Statistiques") {
            this.canAddToCart = true;
            this.canDecreaseQty = true;
            this.products[index].qte = 0;
            this.products[index].qteStock = 0;

            let indexC = this.cart.findIndex(i => i.product == name);
            this.cart.splice(indexC, 1);
            this.headerService.changeNbProduct(this.cart.length);
            this.headerService.changeProducts(JSON.stringify(this.cart));
            localStorage.setItem("cart", JSON.stringify(this.cart));
            if (this.cart.findIndex(i => i.qty > 0) == -1)
                this.canAddToCart = false;
            this.canDecreaseQty = false;

            this.selectScaleBackupAndStats.setValue(null);
            this.scaleSelectBackupAndStats = false;
            this.actualScaleBackupAndStats = new ActivationLicenceInfo();
        } else if (this.products[index].qte > 0) {
            this.canAddToCart = true;
            this.canDecreaseQty = true;
            this.products[index].qte--;
            let price = this.products[index].amountP * this.products[index].qte;
            //this.products[index].amountP = price;
            let cart = JSON.parse(localStorage.getItem("cart"));
            let indexC = this.cart.findIndex(i => i.product == name);

            this.cart[indexC].qty--;

            let priceC = this.cart[indexC].amount * this.cart[indexC].qty;

            this.cart[indexC].tPrice = priceC;
            this.headerService.changeNbProduct(this.cart.length);
            this.headerService.changeProducts(JSON.stringify(this.cart));
            localStorage.setItem("cart", JSON.stringify(this.cart));

            if (this.products[index].qte === 0) {
                let indexC = this.cart.findIndex(i => i.product == name);
                this.cart.splice(indexC, 1);
                this.headerService.changeNbProduct(this.cart.length);
                this.headerService.changeProducts(JSON.stringify(this.cart));
                localStorage.setItem("cart", JSON.stringify(this.cart));
                if (this.cart.findIndex(i => i.qty > 0) == -1)
                    this.canAddToCart = false;
                this.canDecreaseQty = false;

                if (this.products[index].typeP == ProductType.Licence && this.products[index].labelP == "Licence IxellColor Connect") {
                    this.selectScale.setValue(null);
                    this.scaleSelect = false;
                    this.licenceDuration = false;
                    this.actualScale = new ActivationLicenceInfo();
                }
            }
        }
        else {
            this.canDecreaseQty = false;
        }
    }

    openZoomModal(product: IProductV1) {
        this.currentProduct = product;
        this.showModal = true;
        this.isLicenceProduct = (product.labelP == "Licence IxellColor Connect");
    }

    openDetailModal(product: IProductV1) {
        this.currentProduct = product;
        this.showModal = true;

        this.isLicenceProduct = (product.labelP == "Licence IxellColor Connect");
    }

    openNoRenewModal() {
        this.showModalNoRenew = true;
    }

    closeModal() {
        this.currentProduct = null;
        this.showModal = false;
        this.showModalNoRenew = false;
    }

    switchPicture() {
        this.showZoom = !this.showZoom;
    }
}
